import useLocalStorageState from 'use-local-storage-state'
import { useCallback, useMemo, useState } from 'react'

import { axiosInstance } from '../api/axios'
import { JWT_KEY, User_ID_KEY, IS_NEW_USER, IS_LOGINING } from '../constants/localstorage'

export const useAccount = () => {
  const [token, setToken, { removeItem: removeToken }] = useLocalStorageState(JWT_KEY, {
    defaultValue: '',
  })
  const [userId, setUserId, { removeItem: removeUserId }] = useLocalStorageState(User_ID_KEY, {
    defaultValue: '',
  })
  const [isNewUser, setIsNewUser, { removeItem: removeIsNewUser }] = useLocalStorageState(
    IS_NEW_USER,
    {
      defaultValue: false,
    },
  )
  const [isLogining, setIsLogining, { removeItem: removeIsLogining }] = useLocalStorageState(
    IS_LOGINING,
    {
      defaultValue: false,
    },
  )

  // Store token
  const setAuthToken = useCallback(
    (newToken?: string) => {
      if (newToken && !isTokenExpired(newToken)) {
        setToken(newToken)
      }
    },
    [setToken],
  )

  // Remove token
  const removeAuthToken = useCallback(() => {
    removeToken()
    removeIsLogining()
    removeIsNewUser()
  }, [removeToken, removeIsNewUser, removeIsLogining])

  const isLogin = useMemo(() => {
    // return true
    return !!token && !isTokenExpired(token)
  }, [token])

  return {
    token,
    isLogin,
    isLogining,
    setIsLogining,
    setAuthToken,
    setUserId,
    userId,
    removeAuthToken,
    removeUserId,
    isNewUser,
    setIsNewUser,
  }
}

export const decodeJWT = (token: string) => {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(window.atob(base64))
  } catch (error) {
    console.error('Error decoding JWT:', error)
    return null
  }
}

// Check if token is expired
export const isTokenExpired = (token?: string) => {
  if (!token) return true
  const decodedToken = decodeJWT(token)
  if (!decodedToken) return true

  const currentTime = Date.now() / 1000

  return decodedToken.exp < currentTime
}

// Refresh token if it's less than 30 hours from expiration
let isRefreshing = false
const MIN_HOURS_TO_REFRESH = 30
export const refreshToken = async (token: string) => {
  if (!token) return
  if (isRefreshing) return
  isRefreshing = true
  const decodedToken = decodeJWT(token)
  if (!decodedToken) return
  if ((decodedToken.exp - Date.now() / 1000) / 3600 < MIN_HOURS_TO_REFRESH) {
    const response = await axiosInstance.post('/v1/skinsyard/facade/auth/refresh')
    localStorage.setItem(JWT_KEY, `"${response.data.accessToken}"`)
  }
  isRefreshing = false
}
